/* app/js/src/components/media-transcoder/jobs/packager/packager-bulk-create-dialog/packager-bulk-create-dialog.component.scss */
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
.bulk-create-container {
  width: min(92vw, 72rem);
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  padding: 0.5vw 0;
}
.bulk-create-container .header {
  margin-bottom: 0.75vw;
  flex-shrink: 0;
  align-items: center;
}
.bulk-create-container .header h3 {
  margin: 0;
  color: #232f3a;
  font-weight: 600;
}
.bulk-create-container .header .dialog-close-btn {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  background: transparent;
  color: #5a6a7a;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  border-radius: 4px;
}
.bulk-create-container .header .dialog-close-btn:hover {
  background: #eef2f5;
  color: #232f3a;
}
.bulk-create-container .toolbar {
  gap: 0.6vw;
  margin-bottom: 0.75vw;
  flex-shrink: 0;
}
.bulk-create-container .toolbar .toolbar-row {
  gap: 1vw;
  align-items: flex-end;
}
.bulk-create-container .toolbar .toolbar-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.bulk-create-container .toolbar .field-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #232f3a;
}
.bulk-create-container .toolbar .filter-input {
  min-width: 12rem;
  height: 30px;
  padding: 0 10px;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  box-sizing: border-box;
}
.bulk-create-container .toolbar .range-group,
.bulk-create-container .toolbar .mode-group {
  gap: 0.5vw;
}
.bulk-create-container .toolbar .range-input {
  width: 4rem;
  height: 30px;
  padding: 0 8px;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
}
.bulk-create-container .toolbar .link-btn {
  background: none;
  border: none;
  color: #40c4ff;
  cursor: pointer;
  padding: 0;
  font-size: 0.9rem;
}
.bulk-create-container .toolbar .link-btn:hover:not(:disabled) {
  text-decoration: underline;
}
.bulk-create-container .toolbar .link-btn:disabled {
  color: #999;
  cursor: default;
}
.bulk-create-container .toolbar .reschedule-toggle {
  gap: 0.5vw;
  font-size: 0.9rem;
  color: #232f3a;
  cursor: pointer;
}
.bulk-create-container .toolbar .reschedule-toggle input {
  cursor: pointer;
}
.bulk-create-container .mode-btn {
  border: 1px solid #e1e6eb;
  background: #fff;
  color: #232f3a;
  padding: 2px 8px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 0.8rem;
}
.bulk-create-container .mode-btn.active {
  background: #232f3a;
  color: #fff;
  border-color: #232f3a;
}
.bulk-create-container .mode-btn:disabled {
  opacity: 0.5;
  cursor: default;
}
.bulk-create-container .table-wrapper {
  flex: 1;
  min-height: 0;
  overflow: auto;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
}
.bulk-create-container .media-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  color: #232f3a;
  font-size: 0.85rem;
}
.bulk-create-container .media-table th,
.bulk-create-container .media-table td {
  padding: 0.35rem 0.5rem;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #eee;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bulk-create-container .media-table th {
  position: sticky;
  top: 0;
  background: #f5f7f9;
  z-index: 1;
  font-weight: 600;
}
.bulk-create-container .media-table tr:nth-child(even) {
  background: #fdfdfd;
}
.bulk-create-container .media-table tr.row-disabled {
  opacity: 0.65;
}
.bulk-create-container .media-table col.col-check {
  width: 2rem;
}
.bulk-create-container .media-table col.col-num {
  width: 2.5rem;
}
.bulk-create-container .media-table col.col-media {
  width: 12%;
}
.bulk-create-container .media-table col.col-prefix {
  width: 22%;
}
.bulk-create-container .media-table col.col-profiles {
  width: 4rem;
}
.bulk-create-container .media-table col.col-started,
.bulk-create-container .media-table col.col-packager-scheduled {
  width: 9.5rem;
}
.bulk-create-container .media-table col.col-mode {
  width: 9.5rem;
}
.bulk-create-container .media-table col.col-status {
  width: 8rem;
}
.bulk-create-container .media-table .col-started,
.bulk-create-container .media-table .col-packager-scheduled {
  white-space: nowrap;
  font-size: 0.8rem;
}
.bulk-create-container .media-table a {
  color: #40c4ff;
  text-decoration: none;
}
.bulk-create-container .media-table .mode-toggle {
  gap: 0.25rem;
}
.bulk-create-container .media-table .status-badge {
  font-weight: 600;
  text-transform: capitalize;
}
.bulk-create-container .media-table .mode-hint {
  color: #666;
  font-size: 0.75rem;
}
.bulk-create-container .state-message {
  padding: 2rem;
  text-align: center;
  color: #666;
}
.bulk-create-container .footer {
  margin-top: 0.75vw;
  flex-shrink: 0;
  gap: 1vw;
}
.bulk-create-container .footer .selection-summary {
  font-size: 0.9rem;
  color: #232f3a;
}
.bulk-create-container .footer .footer-actions {
  gap: 0.75vw;
  flex-shrink: 0;
}
/*# sourceMappingURL=packager-bulk-create-dialog.component.css.map */
